import { Option } from "components/common/utlis/TypeAnnotations";

export interface ClosureData {
    id: number;
    company_id: number;
    company_name: string;
    start_date: string;
    end_date: string;
    closing_type_id: number;
    closing_type_name: string;
    info: string;
    bright_closing_id: number | null;
    created_by: string;
    updated_by: string;
    updated_at: Date | null;
    created_at: Date | null;
    status?: number;
    archive_reason?: string | null;
}

export interface PaginationData {
    totalPages: number;
    totalRecords: number;
}

export interface SearchProps {
    company: string;
    closingType: Option | null;
    startDate: Date | null;
    endDate: Date | null;
    orderByColumn: string;
    orderIn: "" | "asc" | "desc";
    currentPage: number;
    recordsPerPage: number;
    closureStatus: number | null;
}

export const defaultSearchData: SearchProps = {
    company: "",
    closingType: null,
    startDate: null,
    endDate: null,
    orderByColumn: "",
    orderIn: "",
    currentPage: 1,
    recordsPerPage: 10,
    closureStatus: 1,
};
